<template>
  <f7-list-item ref="listItem" :title="question.title" @click.stop="showPicker">
    <font-awesome-icon icon="edit" slot="content" style="margin-right: 15px; color: #AAAAAA;" />
    <div slot="inner">
      <div
        v-for="(option, index) in question.selectedOptions"
        :key="`number-group-options-${index}`"
        style="color: gray; margin-left: 20px; font-size: 14px; line-height: 20px;">
        <span>{{ option.toString() }} x {{ question.optionAmount(option.id) }}</span>
      </div>
    </div>
  </f7-list-item>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Question from './Question'

export default {
  name: 'NumberGroupQuestion',
  dependencies: ['CartElementBuilder'],
  beforeCreate () {
    // circular reference
    this.$options.components.Question = Question
  },
  mounted () {
    this.$nextTick(() => {
      if (this.focus) {
        this.$f7router.navigate(this.questionUrl)
      }
    })
  },
  computed: {
    ...mapState(['store']),
    ...mapGetters(['currentMenu']),
    question () {
      return this.CartElementBuilder.buildQuestion(this.questionId, this.itemObj, this.currentMenu)
    },
    questionUrl () {
      return `/stores/${this.store.id}/items/${this.itemObj.itemBucket}/${this.itemObj.id}.${this.itemObj.instanceId}/questions/${this.questionId}/number-group-sheet`
    }
  },
  props: {
    questionId: {},
    itemObj: Object,
    focus: Boolean
  },
  watch: {
    focus (focus) {
      if (focus) {
        this.$f7router.navigate(this.questionUrl)
      }
    }
  },
  methods: {
    showPicker () {
      this.$f7router.navigate(this.questionUrl)
    }
  }
}
</script>
